<template>
  <div class="modal-body">
    <span class="modal-body-closebutton">
      <font-awesome-icon
        icon="times"
        size="1x"
        @click.self="$emit('closeModal')"
      />
    </span>

    <!-- 年の選択 -->
    <div class="year-selector">
      <button class="prev-btn" @click="prevYear"></button>
      <span>{{ selectedYear }}年</span>
      <button class="next-btn" @click="nextYear"></button>
    </div>

    <!-- 月の選択 -->
    <div class="months-picker">
      <div
        v-for="(month, index) in defineObject.STR_MONTH_ARRAY"
        :key="index"
        :class="['month-cell', { selected: parseInt(month) === selectedMonth }]"
        @click="handleSelectMonth(month)"
      >
        <div class="month-btn">{{ month }}月</div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'

export default {
  props: {
    initialYearMonth: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleSelectMonth(month) {
      this.selectedMonth = parseInt(month)
      const formattedMonth = month.padStart(2, '0')
      const selectedYearMonth = `${String(this.selectedYear)}/${formattedMonth}`
      this.$emit('selected-year-month', selectedYearMonth)
    },
    prevYear() {
      this.selectedYear--
    },
    nextYear() {
      this.selectedYear++
    },
  },
  data() {
    const [initialYear, initialMonth] = this.initialYearMonth
      ? this.initialYearMonth.split('/').map(Number)
      : [null, null]
    return {
      defineObject: defineObject,
      selectedYear: initialYear ? initialYear : new Date().getFullYear(),
      selectedMonth: initialMonth,
    }
  },
}
</script>
<style lang="scss" scoped>
.modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;

  .modal-body-closebutton {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 25px;
    height: 25px;
    cursor: pointer;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .year-selector {
    margin: 0 auto;
    width: 210px;
    text-align: center;
    position: relative;
    top: 18px;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      background: #fff;
      appearance: none;

      &.prev-btn {
        outline: none;
        border: none;
        display: flex;
        margin-right: 16px;

        &::after {
          content: '';
          display: inline-block;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 9px 15.6px 9px 0;
          border-color: transparent #3c4c64 transparent transparent;
        }
      }

      &.next-btn {
        outline: none;
        border: none;
        display: flex;
        margin-left: 16px;

        &::after {
          content: '';
          display: inline-block;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 9px 0 9px 15.6px;
          border-color: transparent transparent transparent #3c4c64;
        }
      }
    }

    span {
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      color: #3c4c64;
    }
  }

  .months-picker {
    margin-top: 36px;
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, 32px);
    row-gap: 5px;
    text-align: center;

    .month-cell {
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;

      .month-btn {
        margin: 0 auto;
        width: 30px;
        height: 30px;
        color: #3c4c64;
        background: transparent;
        border: none;
        outline: none;
        padding: 0 !important;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &.selected {
        .month-btn {
          border-radius: 50px;
          background: #3acccc !important;
          color: #ffffff !important;
        }
      }
    }
  }
}
</style>
